var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48 376h16v48H48zM80 376h16v16H80zM80 408h16v16H80zM196.46 182.055C212.493 188.468 233.638 192 256 192s43.507-3.532 59.54-9.945C333.893 174.714 344 164.041 344 152s-10.107-22.714-28.46-30.055C299.507 115.532 278.362 112 256 112s-43.507 3.532-59.54 9.945C178.107 129.286 168 139.959 168 152s10.107 22.714 28.46 30.055ZM256 128c43.952 0 72 14.214 72 24s-28.048 24-72 24-72-14.214-72-24 28.048-24 72-24Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 232h-8v-80c0-26.556-18.115-51.144-51.008-69.235C341.611 65.505 300.062 56 256 56s-85.611 9.5-116.992 26.765C106.115 100.856 88 125.444 88 152v112c0 26.556 18.115 51.144 51.008 69.235A184.955 184.955 0 0 0 162.485 344H24a8 8 0 0 0-8 8v96a8 8 0 0 0 8 8h408a64.072 64.072 0 0 0 64-64v-96a64.072 64.072 0 0 0-64-64ZM112 440H32v-80h80Zm296-208h-58.485a184.955 184.955 0 0 0 23.477-10.765c14.741-8.107 26.5-17.523 35.008-27.832ZM146.719 96.784C175.777 80.8 214.588 72 256 72s80.223 8.8 109.281 24.784C392.829 111.936 408 131.544 408 152s-15.171 40.064-42.719 55.216C336.223 223.2 297.412 232 256 232s-80.223-8.8-109.281-24.784C119.171 192.064 104 172.456 104 152s15.171-40.064 42.719-55.216Zm0 222.432C119.171 304.064 104 284.455 104 264v-70.6c8.5 10.309 20.267 19.725 35.008 27.832q6.234 3.429 12.992 6.442V264h16v-29.989a233.64 233.64 0 0 0 24 6.9V264h16v-19.9a282.947 282.947 0 0 0 24 2.945V296h16v-48.106q3.984.1 8 .106h16v16h16v-16h24v16h16v-16h24v48h16v-48h24v16h16v-16h24v16h16v-13.248A48 48 0 0 1 432 344H256c-41.412 0-80.223-8.8-109.281-24.784ZM480 392a48.055 48.055 0 0 1-48 48H128v-80h24v16h16v-16h24v16h16v-16h24v48h16v-48h24v16h16v-16h24v16h16v-16h24v48h16v-48h24v16h16v-16h24v16h16v-18.025a64.071 64.071 0 0 0 32-19.711Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer2);
export default __webpack_public_path__ + "static/media/ser-2.941d4660114e2aaaa23cb8a5ac442cae.svg";
export { ForwardRef as ReactComponent };